module.exports = __webpack_public_path__ + "static/media/sass_css_styled-components.97e769d3.svg";